import { useEffect, useState } from 'react';

/**
 * Fallback UI shown by <Suspense> while a lazy-loaded route is fetching its
 * chunk. Suppressed for the first 200ms so fast loads don't flash.
 */
export function RouteFallback() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const t = window.setTimeout(() => setShow(true), 200);
    return () => window.clearTimeout(t);
  }, []);

  if (!show) return null;

  return (
    <div className="flex min-h-[40vh] items-center justify-center" aria-live="polite" aria-busy="true">
      <div className="flex items-center gap-3 text-ink-muted">
        <span className="relative inline-flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full rounded-full bg-primary opacity-60 animate-ping" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-primary" />
        </span>
        <span className="text-sm font-medium">Loading…</span>
      </div>
    </div>
  );
}
